import React, { useEffect, Fragment } from 'react'
import PropTypes from 'prop-types'
import compose from 'recompose/compose'
import injectJss from 'react-jss'
import { TweenMax, Back } from 'gsap'
import classNames from 'classnames'
import CloseButton from 'public/assets/svg/close-button-black.svg'

import IframeCommunication from 'aria-viewer/common/components/IframeCommunication'

const styles = {
    iframeBackdropContainer: {
        backgroundColor: 'black',
        zIndex: '9999',
        opacity: 0,
        position: 'absolute',
        top: 0,
        width: '100%',
        height: '100%',
    },
    iframeContainer: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        backgroundColor: 'white',
        zIndex: '10000',
        left: '0%',
        top: '0%',
        opacity: 0,
    },
    iframeContainerBorder: {
        left: '5%',
        top: '5%',
        width: '90%',
        height: '90%',
    },
    registrationIframe: {
        width: '100%',
        height: '100%',
        borderWidth: '0px',
        opacity: 0,
    },
    closeButton: {
        cursor: 'pointer',
        width: '20px',
        height: '20px',
        position: 'absolute',
        top: '3%',
        right: '3%',
    },
}

let iframeRef
let containerRef
let backdropRef

// Modal to display iframe contents
// Can have margin with opaque overlay or be fullscreen
const IframeModal = ({ classes, src, onClose, uriParams, hasBorder }) => {
    // Incorporates uriParams into src as query string
    let srcWithParams = `${src}?${Object.keys(uriParams).reduce((paramsString, uriParamsKey) => {
        return paramsString + '&' + `${uriParamsKey}=${uriParams[uriParamsKey]}`
    }, '')}`

    // Animate display of modal
    const animate = {
        display: () => {
            TweenMax.to(iframeRef, 0.5, { opacity: 1.0, ease: Back.easeIn })
            TweenMax.to(containerRef, 0.5, { opacity: 1.0, ease: Back.easeIn })
            TweenMax.to(backdropRef, 0.5, { opacity: 0.5, ease: Back.easeIn })
        },
        hide: () => {
            TweenMax.to(iframeRef, 0.5, { opacity: 0, ease: Back.easeIn })
            TweenMax.to(containerRef, 0.5, { opacity: 0, ease: Back.easeIn })
            TweenMax.to(backdropRef, 0.5, { opacity: 0, ease: Back.easeIn }).eventCallback('onComplete', () => {
                onClose(true)
            })
        },
    }

    return (
        <IframeCommunication
            // eslint-disable-next-line
            children={({ sendMessage }) => (
                <Fragment>
                    <div
                        id={'iframe-modal-backdrop-container'}
                        className={classes.iframeBackdropContainer}
                        ref={backdrop => (backdropRef = backdrop)}
                    />
                    <div
                        id={'iframe-modal-container'}
                        className={classNames([
                            classes.iframeContainer,
                            {
                                [classes.iframeContainerBorder]: hasBorder,
                            },
                        ])}
                        ref={container => (containerRef = container)}
                    >
                        <iframe
                            ref={frame => (iframeRef = frame)}
                            id={'iframe-modal-iframe'}
                            className={classes.registrationIframe}
                            src={srcWithParams}
                            onLoad={() => {
                                // Don't display modal until iframe contents are loaded
                                animate.display()
                            }}
                        />
                        <div
                            className={classes.closeButton}
                            onClick={() => {
                                onClose(false)
                            }}
                        >
                            <img src={CloseButton} />
                        </div>
                    </div>
                </Fragment>
            )}
            onReceiveMessage={({ data }) => {
                // Plays close animation smoothly
                if (data === 'RegistrationForm_Completed') {
                    setTimeout(() => {
                        animate.hide()
                    }, 2000)
                }
            }}
            targetOrigin="*"
        />
    )
}

IframeModal.defaultProps = {
    src: null,
}

IframeModal.propTypes = {
    src: PropTypes.string,
}

export default compose(injectJss(styles))(IframeModal)
